import { mutationTypes, actionTypes } from '@/types';

// Loads CSS file if `cssDevUrl` is set as URL-variable it is loaded if not CSS URL is calculated.
export default async function setStyleTemplate({ state, commit, dispatch }, { exhibitionID }) {
	const cssDevUrl = state.route.query.css;
	if (cssDevUrl) {
		dispatch(actionTypes.setStyleUrl, { styleTemplateURL: cssDevUrl });
		commit(mutationTypes.activeCssMode);
		return;
	}
	let styleTempateHashQuery = '';
	let styleTemplateHashes = [];
	const isExhbitionStyle = exhibitionID && state.dataSourceCFG.exhibitionMap[exhibitionID].styleTemplateID;
	const styleTemplateBaseObject = isExhbitionStyle
		? state.dataSourceCFG.exhibitionMap[exhibitionID]
		: state.dataSourceCFG.global;
	if (!state.dataSourceCFG.global.isProgressiveWebApp && styleTemplateBaseObject.styleTemplateHashes) {
		({ styleTemplateHashes } = styleTemplateBaseObject);
		const [, hash] = styleTemplateHashes.find(([name]) => name === 'main.css');
		styleTempateHashQuery = `?v=${hash}`;
	}
	const { styleTemplateID } = styleTemplateBaseObject;
	const url = new URL(
		`./apps/style-${styleTemplateID}/main.css${styleTempateHashQuery}`,
		state.dataSourceURL
	);
	dispatch(actionTypes.setStyleUrl, { styleTemplateURL: url.toString(), styleTemplateHashes });
}
